export default "__VITE_ASSET__30f2913e__"